import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableContainer, {
    TableContainerProps
} from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination, {
    TablePaginationProps
} from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import theme from 'src/theme';
import { tableStyles } from 'src/shared/Table/styled';

export const InvoicesTableScrollContainer = styled(
    TableContainer
)<TableContainerProps>({
    ...tableStyles.container
});

export const InvoicesTableSurface = styled(Table)({
    backgroundColor: tableStyles.table.backgroundColor,
    minHeight: 300,
    overflowY: 'auto',
    overflowX: 'hidden'
});

export const InvoicesTableHeadRoot = styled(TableHead)({
    ...tableStyles.headRow
});

export const InvoicesTablePaginationBar = styled(
    TablePagination
)<TablePaginationProps>({
    ...tableStyles.pagination,
    '& svg': tableStyles.caret,
    '& .MuiTablePagination-select': tableStyles.paginationSelect,
    '& .MuiTablePagination-toolbar': {
        minHeight: 52
    }
});

export const InvoicesHeaderRow = styled(TableRow)({
    ...tableStyles.dataRow
});

export const InvoicesHeaderCell = styled(TableCell)({
    ...tableStyles.muiTableCell,
    ...tableStyles.headCell,
    ...tableStyles.yellowLabel,
    fontSize: '13px',
    fontWeight: 600,
    lineHeight: '18px',
    paddingTop: '18px',
    paddingBottom: '18px'
});

export const InvoicesDataRow = styled(TableRow)({
    ...tableStyles.dataRow
});

export const InvoicesDataCell = styled(TableCell)({
    ...tableStyles.muiTableCell,
    ...tableStyles.dataCell,
    ...tableStyles.dataCellPadding,
    lineHeight: '22px'
});

export const InvoicesEmptyTableCell = styled(TableCell)({
    border: 'none',
    backgroundColor: tableStyles.table.backgroundColor,
    display: 'block',
    flex: '1 1 100%',
    minWidth: 0,
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box'
});

export const InvoicesCellCenter = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center'
});

export const InvoicesCellActions = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    gap: 12,
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center'
});

export const StatusBadge = styled('span')<{ status: string }>(({ status }) => {
    const colorMap: Record<string, string> = {
        paid: theme.color.freshGreen,
        open: theme.color.lightningYellow,
        draft: theme.color.white50,
        void: theme.color.white30,
        uncollectible: theme.color.brightRed
    };
    const color = colorMap[status] || theme.color.white50;
    return {
        color,
        fontFamily: 'Inter',
        fontWeight: 600,
        fontSize: '12px',
        textTransform: 'uppercase' as const,
        letterSpacing: '0.5px'
    };
});

export const InvoiceLink = styled('a')({
    color: theme.color.lightningYellow,
    textDecoration: 'none',
    fontFamily: 'inherit',
    fontSize: 'inherit',
    fontWeight: 500,
    '&:hover': {
        textDecoration: 'underline'
    }
});

export const EmptyState = styled('div')({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '40px 0',
    color: theme.color.white50,
    fontFamily: 'Inter',
    fontSize: '16px',
    lineHeight: '24px'
});
